var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"service-card",attrs:{"target":"_blank","href":_vm.service.link}},[_c('img',{staticClass:"logo",attrs:{"src":_vm.service.icon,"alt":_vm.service.name}}),_c('p',[_vm._v(_vm._s(_vm.service.name))]),_c('img',{staticClass:"arrow",attrs:{"src":require("../assets/arrow-right.svg"),"alt":"arrow"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }